export default "__VITE_ASSET__DxWGUsv___"